export default function listSummary(list, concurrentDisplayCount = 2) {
    if (list === null) {
        return '';
    }
    const valuesCount = list.length;
    if (valuesCount === 0) {
        return '';
    }
    const displayedValues = [...list].splice(0, concurrentDisplayCount);
    const suffix = valuesCount > concurrentDisplayCount ? ` and ${valuesCount - concurrentDisplayCount} more` : '';
    return `${displayedValues.join(', ')}${suffix}`;
}
